export const SENTRY_DSN =
  'https://ae154f496153468cb6731cabe68b499c@o1288507.ingest.sentry.io/6557709';

export const AMPLITUDE_API_KEY = '367952e4d90c6d93a5e6befa959a58e5';

export const INTERCOM_APP_ID = 'umr1vk9w';
